import NumberInputDisplay from '../../src/legacy/NumberInputDisplay.tsx';
export default NumberInputDisplay;
